import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import focusSessionReducer from './slices/focusSessionSlice';
import analyticsReducer from './slices/analyticsSlice';
import gamesReducer from './slices/gamesSlice';
import projectsReducer from './slices/projectsSlice';
import teamFocusSessionReducer from './slices/teamFocusSessionSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    focusSession: focusSessionReducer,
    analytics: analyticsReducer,
    games: gamesReducer,
    projects: projectsReducer,
    teamFocusSessions: teamFocusSessionReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

